import { useRecoilValue } from 'recoil';
import { selectedFenceIdState } from '../../storage/fences';
import { FenceDetail } from '../fences/FenceDetail';
import { FenceList } from '../fences/FenceList';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';
import { FencesProvider } from '../providers/FencesProvider';

export function FencesPage() {
  const selectedFenceId = useRecoilValue(selectedFenceIdState);

  return (
    <>
      <FencesProvider />
      <FloatingCardsLayout
        contentSize="medium"
        list={<FenceList />}
        content={selectedFenceId !== undefined && <FenceDetail />}
      />
    </>
  );
}
